import React, {Component} from 'react';
import {NavBar,  Toast} from "antd-mobile";
import {addContact, getContacts} from "../../../service/memberService";
import {connect} from "react-redux";
import ExigencyPep from "../../../components/ExigencyPep";
import "./style.less";
@connect(
    state => ({userInfo: state.userInfo})
)
export default class Contacts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contacts: [],
            exigencyModal:false,
        };
    }

    componentDidMount() {
        this.getContactsList();
    }
    getContactsList = () => {
        Toast.loading('',0);
        this.setState({exigencyModal:false});
        let params = {
            source:1,
            token: this.props.userInfo.token,
        };
        getContacts(params).then((res) => {
            if (res.data.code === '0000') {
                this.setState({contacts: res.data.data,});
                Toast.hide()
            } else {
                Toast.info(res.data.msg,3);
            }
        }).catch(function (error) {
            console.log(error);
        });
    };

    onClose = () => {
        this.setState({exigencyModal:false});
    };
    exigencyClick(params){
        // console.log(params);
        addContact(params).then((res)=>{
            if(res.data.code === '0000'){
                Toast.info('添加成功',2,this.getContactsList);
            }else{
                Toast.info(res.data.msg,3)
            }
        });
    }
    render() {
        return (
            <div className="contacts">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >紧急联系人</NavBar>

                <div className="warp">
                    {
                        this.state.contacts ?
                            <div className="contactsList">
                                <div className="contactsItem" >
                                    <i className="icon iconfont icongerenzhongxin"/>
                                    <div className="contact">{this.state.contacts.userName}</div>
                                    <div>{this.state.contacts.phone}</div>
                                </div>
                            </div>:null
                    }
                    <div className="addContact" onClick={() => this.setState({exigencyModal: true})}>
                        <i className="icon iconfont iconpeople"/>
                        <span>添加紧急联系人</span>
                    </div>
                </div>

                <ExigencyPep
                    modal={this.state.exigencyModal}
                    onClose={this.onClose.bind(this)}
                    detele={true}
                    exigencyClick = {this.exigencyClick.bind(this)}
                    {...this.props}
                />

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/Contacts/index.js